import { AccountConfigData } from "~/modules/config";
import { ConfigurationServiceImpl } from "~/backend/generated/Configuration/api/configuration.service";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";

const validAccountConfigDataKeys = [
    "accountSid",
    "attributes",
    "callRecordingEnabled",
    "callRecordingWebhookUrl",
    "channelConfigs",
    "chatServiceInstanceSid",
    "citrixVoiceVdi",
    "crmAttributes",
    "crmCallbackUrl",
    "crmEnabled",
    "crmFallbackUrl",
    "crmType",
    "dateCreated",
    "dateUpdated",
    "debuggerIntegration",
    "flexInstanceSid",
    "flexServiceInstanceSid",
    "flexUiStatusReport",
    "integrations",
    "messagingServiceInstanceSid",
    "outboundCallFlows",
    "pluginServiceAttributes",
    "pluginServiceEnabled",
    "publicAttributes",
    "queueStatsConfiguration",
    "runtimeDomain",
    "serverlessServiceSids",
    "serviceVersion",
    "status",
    "taskrouterOfflineActivitySid",
    "taskrouterSkills",
    "taskrouterTargetTaskqueueSid",
    "taskrouterTargetWorkflowSid",
    "taskrouterTaskqueues",
    "taskrouterWorkerAttributes",
    "taskrouterWorkerChannels",
    "taskrouterWorkspaceSid",
    "uiAttributes",
    "uiDependencies",
    "uiLanguage",
    "uiVersion",
    "url"
];

export const setAccountConfig =
    (ctx: ContextManager) =>
    async (accountSid: string, token: string, config: Partial<AccountConfigData>): Promise<AccountConfigData> => {
        const configurationService = ctx.retrieveInstanceOf(
            ContextInstance.ConfigurationServiceImpl,
            ConfigurationServiceImpl
        );

        const incorrectKeys: Array<string> = Object.keys(config).filter(
            (key: string) => !validAccountConfigDataKeys.includes(key)
        );

        if (incorrectKeys.length > 0) {
            const metadata = {
                module: "config",
                eventSource: "setAccountConfigData.ts",
                severity: ErrorSeverity.Error
            };
            throw new FlexSdkError(ErrorCode.InvalidParams, metadata, `${incorrectKeys[0]} is not a valid key`);
        }

        const updatedConfiguration = await configurationService.updateConfiguration(
            { ...config, accountSid },
            { token }
        );
        return updatedConfiguration;
    };

export async function setAccountConfigData(
    accountSid: string,
    token: string,
    config: Partial<AccountConfigData>
): Promise<AccountConfigData> {
    return setAccountConfig(ContextManager.newInstance())(accountSid, token, config);
}
